import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async';

import {
  createForm,
} from '../../functions/createForm'

import { getFormByIdItemIdPayload } from '../../functions/getFormByIdItemIdPayload'
import { getSkillId } from '../../functions/getSkill'
import { getTabId } from '../../functions/getTab'

import {
  handleInputNameChange,
  handleInputSkillChange,
  handleInputTabChange,
} from '../../utils/functionsInputs'

import { useAuthContext } from '../../hooks/auth'
import { useClearAppCachesOnMount } from '../../hooks/useClearAppCachesOnMount'
import { InputsInfosPages } from '../../components/ui/inputs'
import { ButtonCreateFormPayload } from '../../components/ui/buttons'
import Editor from '@monaco-editor/react';

export default function CreateTemplate() {

  const [isInForce, setIsInForce] = useState(localStorage.getItem("inForce") === "true" ? true : false);
  const { authorizationRA, authorization, authorizationForce, user, signOut } = useAuthContext()
  const token = isInForce ? authorizationForce : authorizationRA;
  const ambient = user?.ambient as string;
  const clientIdForce = localStorage.getItem("clientIdForce") as string;
  const clientId = user?.clientId as string
    ? localStorage.getItem("inForce") === "true"
      ? clientIdForce
      : user?.clientId as string
    : clientIdForce
  const [nameForm, setNameForm] = useState('')
  const [skillIdForm, setSkillIdForm] = useState('')
  const [skillName, setSkillName] = useState('')
  const [tabIdForm, setTabIdForm] = useState('')
  const [tabName, setTabName] = useState('')
  const [idForm, setIdForm] = useState('')
  const [forms, setForms] = useState('')
  const [loadingButtonCreate, setLoadingButtonCreate] = useState(false)
  const [loadingPage, setLoadingPage] = useState(false);
  const [allForm, setAllForm] = useState<any[]>([]);

  useClearAppCachesOnMount();

  useEffect(() => {
    const interval = setInterval(() => {
      const storedInForce = localStorage.getItem("inForce") === "true";
      if (storedInForce !== isInForce) {
        setIsInForce(storedInForce);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [isInForce]);

  const handleSearchForm = async () => {
    setLoadingPage(true);
    const normalizedId = (idForm || "").trim();
    if (!normalizedId) {
      setNameForm('');
      setSkillIdForm('');
      setTabIdForm('');
      setIdForm('');
    } else {
      await getFormByIdItemIdPayload(clientId, normalizedId, ambient, setNameForm, setTabIdForm, setSkillIdForm, setIdForm, setAllForm, token);
    }
    setLoadingPage(false);
  };

  return (
    <div className="bg-page">
      <Helmet>
        <title>Criar fomulário por payload</title>
      </Helmet>

      <div className="bg-page-create-form-payload w-full px-2 sm:px-4 md:px-6 py-4 payload-page">
        <div className="form-page-shell">
          <div className="form-config-card">
            <div className="form-card-header">
              <div>
                <h2 className="form-card-title">Criar formulário por payload</h2>
                <p className="form-card-subtitle">Preencha os dados base antes de enviar o payload</p>
              </div>
            </div>

            <div className="form-card-body">
              <div className="infos-form-header w-full space-y-3 sm:space-y-4">
                <div className="form-info-row">
                  <label className="form-info-label">Id</label>
                  <div className="header-fields-item flex-1 w-full">
                    <InputsInfosPages
                      placeholder='Insira o id do formulário'
                      type='text'
                      value={idForm}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setIdForm(event.target.value)
                      }}
                      onBlur={() => handleSearchForm()}
                    />
                  </div>
                </div>

                <div className="form-info-row">
                  <label className="form-info-label">Nome</label>
                  <div className="header-fields-item flex-1 w-full">
                    <InputsInfosPages
                      placeholder='Insira o nome do formulário'
                      type='text'
                      value={nameForm}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        handleInputNameChange(event, setNameForm)
                      }
                    />
                  </div>
                </div>

                <div className="form-info-row">
                  <label className="form-info-label">SkillId</label>
                  <div className="header-fields-item flex-1 w-full">
                    <InputsInfosPages
                      placeholder='Insira a skillId'
                      type='text'
                      value={skillIdForm}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        handleInputSkillChange(event, setSkillIdForm)
                      }
                      onBlur={() => getSkillId(skillIdForm, token, ambient, setSkillName, isInForce)}
                    />
                  </div>
                </div>

                <div className="form-info-row">
                  <label className="form-info-label">TabId</label>
                  <div className="header-fields-item flex-1 w-full">
                    <InputsInfosPages
                      placeholder='Insira a tabId'
                      type='text'
                      value={tabIdForm}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        handleInputTabChange(event, setTabIdForm)
                      }
                      onBlur={() => getTabId(tabIdForm, token, ambient, setTabName, isInForce, skillIdForm)}
                    />
                  </div>
                </div>
              </div>

              <div className="form-payload-actions">
                <ButtonCreateFormPayload
                  loadingButtonCreate={loadingButtonCreate}
                  onClick={() => {
                    createForm(
                      setLoadingButtonCreate,
                      forms,
                      setForms,
                      authorization,
                      token,
                      nameForm,
                      skillIdForm,
                      tabIdForm,
                      idForm,
                      ambient,
                      setTabName,
                      setSkillName,
                      setIdForm,
                      setNameForm,
                      setSkillIdForm,
                      setTabIdForm,
                      isInForce,
                      idForm.trim() && allForm[0]?.id === idForm.trim()
                        ? allForm[0]
                        : undefined,
                      user?.google?.id,
                      user?.google?.name ?? user?.userName ?? null,
                      user?.clientId ?? clientId ?? null,
                      user?.clientName ?? null,
                    )
                  }} />
              </div>
            </div>
          </div>

          <div className="form-payload-card">
            <div className="form-payload-header">
              <h3 className="form-card-title">Payload do formulário</h3>
              <p className="form-card-subtitle">Cole ou edite o JSON do formulário</p>
            </div>
            <div className="form-payload-body">
              <div className="form-payload-editor">
                <Editor
                  height="420px"
                  language="json"
                  value={forms}
                  onChange={(value) => setForms(value ?? '')}
                  theme="vs-light"
                  options={{
                    minimap: { enabled: false },
                    fontSize: 13,
                    lineNumbers: 'on',
                    scrollBeyondLastLine: false,
                    wordWrap: 'on',
                    tabSize: 2,
                    formatOnPaste: true,
                    formatOnType: true,
                    automaticLayout: true,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}